export default __webpack_public_path__ + "static/media/logoSpinner3.ab3a9f5a.png";